import { applePaySessionApi } from '../../api/apple-pay-session';
import { BeginApplePaySessionParams } from '../../types';

import {
    createFrameApplePayCancelMessage,
    createFrameApplePayFailureMessage,
    createFrameApplePaySuccessMessage,
} from './frame-apple-pay-message';

export const beginApplePaySession = ({
    apiHost,
    purchaseToken,
    merchantId,
    request,
    onSendResponse,
}: BeginApplePaySessionParams) => {
    const session = new ApplePaySession(3, request);

    session.onvalidatemerchant = async (event) => {
        try {
            const merchantSession = await applePaySessionApi(apiHost, {
                validationURL: event.validationURL,
                purchaseToken,
                merchantId,
            });

            session.completeMerchantValidation(merchantSession);
        } catch (_e) {
            onSendResponse(createFrameApplePayFailureMessage());

            session.abort();
        }
    };

    session.onpaymentauthorized = (event) => {
        onSendResponse(createFrameApplePaySuccessMessage(event.payment, merchantId));

        /**
         * Закрываем шторку ApplePay
         */
        session.completePayment({
            status: ApplePaySession.STATUS_SUCCESS,
        });
    };

    session.oncancel = () => {
        onSendResponse(createFrameApplePayCancelMessage());
    };

    session.begin();
};
